import { combineReducers } from "redux";
import heat_map from "../features/admin/heat_map/heat_map/Slice";
import heat_map_cab from "../features/admin/heat_map/heat_map_cab/Slice";

const form = combineReducers({
  heat_map: heat_map,
  heat_map_cab: heat_map_cab,
});

export default form;
